import { notifyMessage } from 'src/constants/message';
import { notification } from 'core-ui';
import { get, isObject, isString, omit, toNumber } from 'lodash';
import { dayjs } from 'core-helpers';
import { apiRequest } from './api';
import { FormInstance } from 'core-ui';
import { DATE_FORMAT } from 'src/constants/date';

export const handleError = (error: any) => {
  console.log({ error });

  const resMessage = error?.response?.data?.errors;
  const errorMessage = isString(resMessage) ? resMessage : notifyMessage.failed;

  notification.error({
    message: errorMessage
  });
};
export function objectToFormData(obj: any, form = null, namespace = '') {
  const formData = form || new FormData();

  for (const property in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, property)) {
      const value = obj[property];
      // Kiểm tra để loại bỏ giá trị undefined và null
      if (value === undefined || value === null || property === '') continue;

      const formKey = namespace ? `${namespace}[${property}]` : property;
      if (dayjs.isDayjs(value)) {
        formData.append(formKey, value.toString());
      } else if (Array.isArray(value)) {
        value.forEach((element, index) => {
          if (
            typeof element === 'object' &&
            !(element instanceof File) &&
            !(element instanceof Blob)
          ) {
            objectToFormData(element, formData as any, `${formKey}[${index}]`);
          } else {
            formData.append(`${formKey}[${index}]`, element);
          }
        });
      } else if (
        typeof value === 'object' &&
        !(value instanceof File) &&
        !(value instanceof Blob)
      ) {
        objectToFormData(value, formData as any, formKey);
      } else {
        formData.append(formKey, value);
      }
    }
  }

  return formData;
}
export function trimObjectValues(obj: any) {
  for (let key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = obj[key].trim();
    } else if (
      typeof obj[key] === 'object' &&
      !Array.isArray(obj[key]) &&
      obj[key] !== null
    ) {
      trimObjectValues(obj[key]);
    }
  }
  return obj;
}

export const removeSearchPage = () => {
  localStorage.removeItem('page');
};

export const saveSearchPage = (page: number) => {
  localStorage.setItem('page', page + '');
};

export const getSearchPage = () => {
  return localStorage.getItem('page')
    ? toNumber(localStorage.getItem('page'))
    : 1;
};

export const saveSearch = (
  scope: string,
  searchTerm: { [key: string]: any }
) => {
  const dataSave = { ...searchTerm };
  if (isObject(searchTerm)) {
    Object.keys(searchTerm).forEach((searchKey) => {
      const key = searchKey as keyof typeof searchTerm;
      if (searchKey == 'page') {
        saveSearchPage(searchTerm[key]);
      }
      if (dayjs.isDayjs(searchTerm[key])) {
        dataSave[searchKey] = dayjs(searchTerm[key]).format(DATE_FORMAT);
      }
    });
  }
  const dataJSON = JSON.stringify({
    searchTerm: omit(dataSave, 'page'),
    scope
  });
  apiRequest.post({ data: dataJSON, url: '/api/admin/user-search' });
};

export const setSearch = async (scope: string, form: FormInstance) => {
  try {
    const data = await apiRequest.get({
      url: '/api/admin/user-search',
      params: { scope }
    });
    const searchTerm = get(data, 'data.data.searchTerm');
    const page = getSearchPage();

    if (isObject(searchTerm)) {
      Object.keys(searchTerm).forEach((key) => {
        const value = get(searchTerm, key, '');
        if (dayjs(value, DATE_FORMAT, true).isValid()) {
          form.setFieldValue(key, dayjs(value, DATE_FORMAT));
        } else if (key === 'repairDate' && Array.isArray(value)) {
          const parsedDates = value.map((dateObj) => dayjs(dateObj));
          form.setFieldValue(key, parsedDates);
        } else if (key === 'createdDate' && Array.isArray(value)) {
          const parsedDates = value.map((dateObj) => dayjs(dateObj));
          form.setFieldValue(key, parsedDates);
        } else if (key === 'paymentDate' && Array.isArray(value)) {
          const parsedDates = value.map((dateObj) => dayjs(dateObj));
          form.setFieldValue(key, parsedDates);
        } else if (key === 'searchPeriod' && Array.isArray(value)) {
          const parsedDates = value.map((dateObj) => dayjs(dateObj));
          form.setFieldValue(key, parsedDates);
        } else {
          form.setFieldValue(key, value);
        }
      });
    }
    form.setFieldValue('page', page);

    return data;
  } catch (e) {
    console.log(e);
  }
};

export const setListDontHighLightMenu = (
  key: string,
  value: boolean,
  reset?: boolean
) => {
  if (reset) {
    return localStorage.setItem('listDontHighLight', '{}');
  }
  const preValueJson = localStorage.getItem('listDontHighLight') || '{}';
  const preValue = JSON.parse(preValueJson);
  const valueNew = value ? { ...preValue, [key]: true } : omit(preValue, key);
  localStorage.setItem('listDontHighLight', JSON.stringify(valueNew));
};

export const getListDontHighLightMenu = () => {
  const valueJson = localStorage.getItem('listDontHighLight') || '{}';
  return JSON.parse(valueJson);
};

export const getMimeType = (fileName: string) => {
  const lower = fileName.toLowerCase();

  if (lower.endsWith('.png')) return 'image/png';
  if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'image/jpeg';
  if (lower.endsWith('.gif')) return 'image/gif';
  if (lower.endsWith('.bmp')) return 'image/bmp';
  if (lower.endsWith('.webp')) return 'image/webp';

  if (lower.endsWith('.pdf')) return 'application/pdf';
  if (lower.endsWith('.doc') || lower.endsWith('.docx'))
    return 'application/msword';
  if (lower.endsWith('.xls') || lower.endsWith('.xlsx'))
    return 'application/vnd.ms-excel';
  if (lower.endsWith('.txt')) return 'text/plain';
  if (lower.endsWith('.zip')) return 'application/zip';

  return 'application/octet-stream';
};

export const convertNullToEmptyString = (obj: any, keys: string[]) => {
  keys.forEach((key) => {
    if (key.includes('[')) {
      const [parentKey, childKey] = key.split(/\[|\]/).filter(Boolean);
      if (obj[parentKey] && obj[parentKey][childKey] === null) {
        obj[parentKey][childKey] = '';
      }
    } else {
      if (obj[key] === null) obj[key] = '';
    }
  });
};

export const formatNumber = (num: number | string): string => {
  if (typeof num === 'undefined' || num === null) {
    return '';
  }
  return new Intl.NumberFormat('ja-JP').format(Number(num));
};

export const transformCustomFields = (customFields: Record<string, any>) => {
  const result: Record<string, any> = {};
  let index = 0;

  Object.values(customFields || {}).forEach((field) => {
    const { label, value } = field || {};
    if (!label && !value) return;

    result[index] = { label, value };
    index++;
  });

  return result;
};

export const setSearchWithAgency = async (
  scope: string,
  form: FormInstance,
  isAgencyValid: boolean
) => {
  try {
    const data = await apiRequest.get({
      url: '/api/admin/user-search',
      params: { scope }
    });
    const searchTerm = get(data, 'data.data.searchTerm') as {
      startInsStartDate?: string;
      endInsStartDate?: string;
      startWarStartDate?: string;
      endWarStartDate?: string;
      [key: string]: any;
    };
    const page = getSearchPage();

    if (isObject(searchTerm)) {
      if (searchTerm?.dateSearching && Array.isArray(searchTerm?.rangeDate)) {
        form.setFieldValue('dateSearching', searchTerm.dateSearching);
        form.setFieldValue(
          'rangeDate',
          searchTerm.rangeDate.map((d: string) => dayjs(d))
        );
      }
      Object.keys(searchTerm).forEach((key) => {
        const value = get(searchTerm, key, '');

        // Skip agency-related fields if agencyId is invalid
        // (invalid = agencyId exists AND agency detail API returned 400 (agencyId is removed or not exist in DataBase))
        if (
          (key === 'agencyId' || key === 'selectedAgencyId') &&
          !isAgencyValid
        ) {
          return;
        }

        if (key === 'rangeDate') return;

        if (dayjs(value, DATE_FORMAT, true).isValid()) {
          form.setFieldValue(key, dayjs(value, DATE_FORMAT));
        } else if (key === 'repairDate' && Array.isArray(value)) {
          const parsedDates = value.map((dateObj) => dayjs(dateObj));
          form.setFieldValue(key, parsedDates);
        } else if (key === 'createdDate' && Array.isArray(value)) {
          const parsedDates = value.map((dateObj) => dayjs(dateObj));
          form.setFieldValue(key, parsedDates);
        } else if (key === 'paymentDate' && Array.isArray(value)) {
          const parsedDates = value.map((dateObj) => dayjs(dateObj));
          form.setFieldValue(key, parsedDates);
        } else if (key === 'serviceStartAt' && Array.isArray(value)) {
          const parsedDates = value.map((dateObj) => dayjs(dateObj));
          form.setFieldValue(key, parsedDates);
        } else if (key === 'registerDate' && Array.isArray(value)) {
          const parsedDates = value.map((dateObj) => dayjs(dateObj));
          form.setFieldValue(key, parsedDates);
        } else {
          form.setFieldValue(key, value);
        }
      });
    }
    form.setFieldValue('page', page);

    return data;
  } catch (e) {
    console.log(e);
  }
};
